export default __webpack_public_path__ + "static/media/hello.ca2496fe.mp4";